import { ColDef } from "ag-grid-enterprise";
import {
	EditButtonCellRenderer,
	ToggleStatusButtonCellRenderer,
} from "./ButtonCellRenderer";

export const blankToEndComparator = (
	valueA: any,
	valueB: any,
	_nodeA: any,
	_nodeB: any,
	isDescending: boolean,
) => {
	const isBlank = (val: any) =>
		val === null || val === undefined || String(val).trim() === "";

	const aBlank = isBlank(valueA);
	const bBlank = isBlank(valueB);

	if (aBlank && bBlank) return 0;

	if (aBlank) return isDescending ? -1 : 1;
	if (bBlank) return isDescending ? 1 : -1;

	if (valueA < valueB) return -1;
	if (valueA > valueB) return 1;
	return 0;
};

type Props = {
	OnEdit?: Function;
	OnSend?: Function;
};

export const useGridDefinitions = ({ OnEdit, OnSend }: Props) => {
	const defaultColDef: ColDef = {
		comparator: blankToEndComparator,
		flex: 1,
		filter: false,
		floatingFilter: false,
		sortable: true,
		editable: false,
		resizable: false,
		wrapText: false,
		autoHeight: false,
		wrapHeaderText: true,
		suppressHeaderMenuButton: true,
		cellStyle: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
	};
	const columnDefaults: ColDef = {
		minWidth: 20,
		flex: 1,
		filter: true,
		floatingFilter: false,
		sortable: true,
		resizable: true,
		editable: false,
	};
	const columnSimpleDefaults: ColDef = {
		minWidth: 20,
		flex: 1,
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
	};
	const columnGenericDefaults: ColDef = {
		minWidth: 20,
		filter: true,
		floatingFilter: false,
		sortable: true,
		resizable: false,
		editable: false,
	};
	const columnTypes: { [key: string]: ColDef } = {
		nonEditableColumn: { editable: false },
		nonSorteable: { sortable: false },
		nonFilterable: { filter: false },
		numericWidth: { width: 80 },
		centerAligned: {
			headerClass: "ag-center-aligned-header",
			cellClass: "ag-center-aligned-cell",
		},
		editButton: {
			field: "Edit",
			cellRenderer: EditButtonCellRenderer,
			cellRendererParams: {
				clicked: (field: any) => {
					if (OnEdit) OnEdit(field);
				},
			},
			cellClass: "ag-button-cell",
		},
		statusButton: {
			field: "Enabled",
			cellRenderer: ToggleStatusButtonCellRenderer,
			cellRendererParams: {
				isEnabled: "Enabled",
				clicked: (field: any) => {
					alert(`${field.Decimals} was clicked`);
				},
			},
			cellClass: "ag-button-cell",
		},
	};

	return {
		defaultColDef,
		columnDefaults,
		columnSimpleDefaults,
		columnTypes,
		columnGenericDefaults,
	};
};
